/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".title_container[_ngcontent-%COMP%]{display:flex;gap:8px;justify-content:center;align-items:center;width:100%}.title_container[_ngcontent-%COMP%]   .alarm-icon[_ngcontent-%COMP%]{font-size:30px;height:30px;width:30px;margin-bottom:5px}.title_container[_ngcontent-%COMP%]   .title_text[_ngcontent-%COMP%]{color:#4c4c4c;font-size:27px}.content_container[_ngcontent-%COMP%]{font-size:18px;padding:0 40px;color:#9e1b32;list-style-type:disc}.cta_container[_ngcontent-%COMP%]{display:flex;justify-content:center;gap:20px}"];
export { styles as styles };
